import { get, post, put } from '@/utils/request'

/** 浏览器驱动状态 */
export interface BrowserDriver {
  browser_code: string
  browser_name: string
  /** system=系统浏览器 / playwright=Playwright托管 */
  driver_type: string
  installed: boolean
  path: string
  is_default: boolean
  /** none / installing / success / failed */
  install_status: string
  install_message: string
}

/** 浏览器驱动列表 */
export const listDrivers = () => get<BrowserDriver[]>('/browser-drivers')

/** 一键安装浏览器驱动 */
export const installDriver = (browserCode: string) =>
  post<{ accepted: boolean }>(`/browser-drivers/${browserCode}/install`)

/** 设为默认浏览器 */
export const setDefaultDriver = (browserCode: string) =>
  put<BrowserDriver>(`/browser-drivers/${browserCode}/default`)
